module.exports = __webpack_public_path__ + "static/media/stack-vector.b5caa575.svg";